import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::returnMethod
* @see app/Http/Controllers/Creator/TeamInvitationController.php:161
* @route '/app/creator/team/checkout/return'
*/
export const returnMethod = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: returnMethod.url(options),
    method: 'get',
})

returnMethod.definition = {
    methods: ["get","head"],
    url: '/app/creator/team/checkout/return',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::returnMethod
* @see app/Http/Controllers/Creator/TeamInvitationController.php:161
* @route '/app/creator/team/checkout/return'
*/
returnMethod.url = (options?: RouteQueryOptions) => {
    return returnMethod.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::returnMethod
* @see app/Http/Controllers/Creator/TeamInvitationController.php:161
* @route '/app/creator/team/checkout/return'
*/
returnMethod.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: returnMethod.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::returnMethod
* @see app/Http/Controllers/Creator/TeamInvitationController.php:161
* @route '/app/creator/team/checkout/return'
*/
returnMethod.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: returnMethod.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::returnMethod
* @see app/Http/Controllers/Creator/TeamInvitationController.php:161
* @route '/app/creator/team/checkout/return'
*/
const returnMethodForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: returnMethod.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::returnMethod
* @see app/Http/Controllers/Creator/TeamInvitationController.php:161
* @route '/app/creator/team/checkout/return'
*/
returnMethodForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: returnMethod.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::returnMethod
* @see app/Http/Controllers/Creator/TeamInvitationController.php:161
* @route '/app/creator/team/checkout/return'
*/
returnMethodForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: returnMethod.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

returnMethod.form = returnMethodForm

const checkout = {
    return: Object.assign(returnMethod, returnMethod),
}

export default checkout